function storeUpdated(event, dropdownElementReference, callback) {
	const newValueOptions = event.newValue[dropdownElementReference].options;

	if (newValueOptions.length === 0) return callback(null);

	// If oldValueOptions do no exist, return callback with newValueOptions
	if (Object.keys(event.oldValue).length === 0) {
		return callback(newValueOptions);
	}

	const oldValueOptions = event.oldValue[dropdownElementReference].options;

	if (
		JSON.stringify(sortByValue(oldValueOptions)) !==
		JSON.stringify(sortByValue(newValueOptions))
	) {
		return callback(event.newValue[dropdownElementReference].options);
	}

	return null;
}

function sortByValue(arr) {
	if (!arr) return [];
	return [...arr].sort((a, b) => a.value - b.value);
}

function createInitialDropdownData(inkTonerConfig) {
	const newData = Object.assign({}, inkTonerConfig);
	const { inkTonerOptions } = window.od;

	Object.keys(newData).forEach((dropdownId, dropdownIndex) => {
		const selectedId = window.od.inkTonerOptions.selected[dropdownId];
		const mappedOptions = mapOptions(
			inkTonerOptions[dropdownId],
			selectedId,
			dropdownIndex,
		);

		newData[dropdownId].options = mappedOptions;
		newData[dropdownId].selectedOption = getSelectedOption(mappedOptions);
	});
	return newData;
}

function mapOptions(data, selectedId, dropdownIndex) {
	if (!data) return [];
	// If first dropdown with only one option available, preselect this option
	if (dropdownIndex === 0 && data.length === 1) return mapSingleOption(data);
	return mapMultipleOptions(data, selectedId);
}

function mapSingleOption(data) {
	return data.map(option => ({
		label: option.name,
		value: parseInt(option.code, 10),
		selected: true,
		disabled: Object.hasOwnProperty.call(option, 'enabled') && !option.enabled,
		customProperties: {
			deviceUrl: option.deviceUrl,
		},
	}));
}

function mapMultipleOptions(data, selectedId) {
	return data.map(option => ({
		label: option.name,
		value: parseInt(option.code, 10),
		selected: parseInt(option.code, 10) === selectedId,
		disabled: Object.hasOwnProperty.call(option, 'enabled') && !option.enabled,
		customProperties: {
			deviceUrl: option.deviceUrl,
		},
	}));
}

function getSelectedOption(mappedOptions) {
	if (!mappedOptions) return {};
	if (mappedOptions.length === 1) return mappedOptions[0];
	return mappedOptions.find(options => options.selected === true) || {};
}

function generateInput(name, value, type) {
	const newInput = document.createElement('input');
	newInput.setAttribute('type', type);
	newInput.setAttribute('name', name);
	newInput.setAttribute('value', value);
	return newInput;
}

export {
	storeUpdated,
	mapOptions,
	createInitialDropdownData,
	sortByValue,
	generateInput,
};
